module.exports = __webpack_public_path__ + "img/16581252_L.e121b02a.png";